import { OrderConfirmationPageGuard } from './order-confirmation-page.guard';

export const guards: any[] = [OrderConfirmationPageGuard];
